import { Form } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DeliveryOrganizationChooser } from 'components/choosers/DeliveryOrganizationChooser';
import { Button, Modal, ModalActionButtons } from 'components/ui';

interface ITaskForOrganizationEditorProps {
  defaultOrgId: string | undefined;
  assetId: string;
  onSave: (id: string) => void;
}
export const TaskForOrganizationEditor: React.FunctionComponent<
  ITaskForOrganizationEditorProps
> = ({ defaultOrgId, onSave, assetId }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);
  const [form] = Form.useForm();
  const formKey = 'forOrganization';

  const handleSave = () => {
    setVisible(false);
    const orgId = form.getFieldValue(formKey);
    onSave(orgId);
  };
  function handleClose() {
    setVisible(false);
  }

  return (
    <Modal
      title={t('tasks.editForOrganization', 'Edit For Organization')}
      open={visible}
      footer={null}
      onCancel={handleClose}
    >
      <Form layout="vertical" form={form} onFinish={handleSave}>
        <Form.Item name={formKey} label={t('inspection.forOrganization', 'For Organization')}>
          <DeliveryOrganizationChooser
            formKey={formKey}
            form={form}
            assetIds={[assetId]}
            defaultOrgId={defaultOrgId}
          />
        </Form.Item>
        <ModalActionButtons>
          <Button onClick={handleClose}>{t('common.cancel', 'Cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {t('common.edit', 'Edit')}
          </Button>
        </ModalActionButtons>
      </Form>
    </Modal>
  );
};
